const MobileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" viewBox="0 0 16 22">
        <path
            id="Layer_1-2"
            fill="#fff"
            d="M2 12.25V20 2zM2 22c-.55 0-1.02-.2-1.41-.59S0 20.55 0 20V2C0 1.45.2.98.59.59S1.45 0 2 0h10c.55 0 1.02.2 1.41.59S14 1.45 14 2v2h-2V2H2v18h10v-2h2v2c0 .55-.2 1.02-.59 1.41S12.55 22 12 22zm5.71-3.5c.19-.19.29-.43.29-.71s-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29.52-.1.71-.29m3.62-4.65L9.88 12.4c.2-.18.35-.4.46-.64s.16-.5.16-.76-.05-.52-.16-.76-.26-.45-.46-.64l1.45-1.45c.38.38.68.82.88 1.31s.3 1 .3 1.54-.1 1.05-.3 1.54-.49.93-.88 1.31m2.45 2.45-1.4-1.4c.52-.52.92-1.11 1.2-1.78s.43-1.38.43-2.13-.14-1.46-.43-2.13-.68-1.26-1.2-1.78l1.4-1.4q1.08 1.05 1.65 2.43c.57 1.38.58 1.88.58 2.88s-.19 1.96-.58 2.88-.93 1.73-1.65 2.43"
        ></path>
    </svg>
);

export default MobileIcon;
